<!--
 * @Author: 汪俊洪
 * @Date: 2025-06-26 16:55:05
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-06-26 17:06:17
 * @Description:
-->
<template>
  <div>
    <div>检测到您在平台有渠道商账户，请选择企业进入渠道商页面。</div>
    <div style="padding-top: 20px; max-height: 300px; overflow-y: auto">
      <div v-for="(item, index) in list" :key="index">
        <a href="javascript:" @click="toPlcPage(item)">
          {{ item.companyName }}
        </a>
      </div>
    </div>
    <div style="text-align: center; padding-top: 20px" class="dialog-footer">
      <el-button size="small" @click="cancel">关闭</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    toPlcPage (item) {
      const obj = {
        ...this.$store.state.user,
        defaultCompanyId: item.companyId,
        defaultCompanyName: item.companyName
      }
      sessionStorage.setItem('plcUserInfo', JSON.stringify(obj))
      window.open('/plc')
      sessionStorage.remove('plcUserInfo')
    },
    cancel () {
      sessionStorage.setItem('plcTip', '1')
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped></style>
